import {
  getCategoriesThunk,
  getProjectThunk,
} from "../redux/reducers/ui/uiThunks";
import { AppDispatch, store } from "../redux/store";
import { popUp } from "../features/popUp/PopUp";
import { MOCK_ORGANIZATION_ID } from "../utils/constants";

export class EnvironmentService {
  static async fetchEnvironments(dispatch: AppDispatch) {
    try {
      await dispatch(getProjectThunk(MOCK_ORGANIZATION_ID)).unwrap();
      await dispatch(getCategoriesThunk(MOCK_ORGANIZATION_ID)).unwrap();
    } catch (e: any) {
      popUp({ type: "failure", message: e.message });
    }
  }

  static getActiveStage(): any | [] {
    const state = store.getState();
    const { activeEnvironmentId, environments } = state.ui;
    const params = new URLSearchParams(document.location.search);
    const environmentId = params.get("list_id");
    // Prefer URL id if valid digits, otherwise use state.activeEnvironmentId
    const urlId =
      environmentId && /^\d+$/.test(environmentId)
        ? Number(environmentId)
        : undefined;
    const ACTIVE_ID =
      urlId ??
      (Number.isFinite(activeEnvironmentId)
        ? Number(activeEnvironmentId)
        : NaN);

    if (!environments || !environments.length || !Number.isFinite(ACTIVE_ID)) {
      popUp({ type: "failure", message: "Stage list is empty" });
      return [];
    } else {
      return environments.find((stage: any) => stage.id === ACTIVE_ID);
    }
  }

  static getAllAvailableStagesOptions() {
    const state = store.getState();

    // Get the current environment from environmentsStage (from getProjectStagesThunk)
    const currentEnv = state.ui.environmentsStage.find(
      (env: any) => env.id === state.ui.activeEnvironmentId
    );

    console.log("currentEnv", currentEnv);
    console.log("state.ui.environmentsStage", state.ui.environmentsStage);
    console.log("state.ui.activeEnvironmentId", state.ui.activeEnvironmentId);

    if (!currentEnv) {
      return undefined;
    }

    const availableOptions = currentEnv.availableOptions || [];
    const availableGeometryOptions = currentEnv.availableGeometryOptions || [];
    let allOptions: any[] = [];

    // Process material options
    if (availableOptions.length) {
      const materialProxyOptions = availableOptions
        .filter(
          (proxyOption: any) =>
            proxyOption.enabled &&
            proxyOption.materialOptions?.some((material: any) =>
              material.variants?.some((variant: any) => variant.enabled)
            )
        )
        .map((proxyOption: any) => ({
          ...proxyOption,
          proxyOptions: proxyOption.materialOptions,
        }));
      allOptions = [...allOptions, ...materialProxyOptions];
    }

    // Process geometry options
    if (availableGeometryOptions.length) {
      const geometryProxyOptions = availableGeometryOptions
        .filter(
          (proxyOption: any) =>
            proxyOption.enabled &&
            proxyOption.geometryOptions?.some((material: any) =>
              material.variants?.some((variant: any) => variant.enabled)
            )
        )
        .map((proxyOption: any) => ({
          ...proxyOption,
          proxyOptions: proxyOption.geometryOptions,
        }));

      allOptions = [...allOptions, ...geometryProxyOptions];
    }

    console.log("allOptions", allOptions);
    return allOptions;
  }

  static getAllProxyVariants(array: any[]) {
    return array?.flatMap(item =>
      item.variants
        .map(
          (variant: {
            id: number;
            name: string;
            image: string;
            enable: boolean;
          }) => ({
            ...variant,
            playcanvasString: item.playcanvasString,
          })
        )
        .filter((stage: any) => stage.enabled)
    );
  }

  static getSelectedEnvironmentOption(
    environment: any,
    property: string,
    optionsType: "materialOptions" | "geometryOptions"
  ): any[] {
    let formattedOptions: any[] = [];

    if (!environment) {
      popUp({ type: "warning", message: "Please chose an Environment" });
    }

    const windowPlay =
      // @ts-ignore
      window.containerRef.current.contentWindow.VividMaterialAPI;
    environment?.[property]?.forEach((option: any) => {
      const { proxyName, id: proxyOptionId } = option;
      const objects = windowPlay.findAllChangers();

      objects.map((object: any) => {
        const activeName = windowPlay.getValueMaterail(object.name, proxyName);

        if (activeName) {
          const activeVariant = option[optionsType]
            .flatMap((materialItem: any) => materialItem.variants)
            .find((item: any) => item.name === activeName.name);

          formattedOptions = [
            ...formattedOptions,
            {
              proxyName,
              proxyId: proxyOptionId,
              val: activeVariant.id,
              valName: activeVariant.name,
              resourceUrl: option[optionsType][0].resource,
              type: property === "availableOptions" ? "material" : "geometry",
            },
          ];
        }
      });
    });
    return formattedOptions;
  }

  static getFormattedEnvironmentData(stage: any) {
    const data = {
      id: stage.id,
      name: stage.name,
      paramString: stage.paramString,
      resourceUrl: stage?.resource,
      options: [
        ...this.getSelectedEnvironmentOption(
          stage,
          "availableOptions",
          "materialOptions"
        ),
        ...this.getSelectedEnvironmentOption(
          stage,
          "availableGeometryOptions",
          "geometryOptions"
        ),
      ],
    };

    return data;
  }
}
